import { useEffect, useLayoutEffect } from "react";
import { debounce } from "lodash";
import { setScrollElement } from "store/global/global.actions";
import { SCROLL_BAR_VIEW_ID } from "components/ScrollBar";
const toBoundingBox = (r) => r
    ? {
        x: r.x,
        y: r.y,
        width: r.width,
        height: r.height,
        top: r.top,
        right: r.right,
        bottom: r.bottom,
        left: r.left,
    }
    : undefined;
export const scrollListener = (dispatch, element) => (isScroll, boundingBox) => {
    dispatch(setScrollElement({
        element,
        isScroll,
        boundingBox: toBoundingBox(boundingBox),
    }));
};
export const useOnScrollPopoverStateListener = (popoverIsOpened, setPopoverIsOpened, popoverRef, elementScroll) => {
    useEffect(() => {
        const { isScroll, boundingBox } = { ...elementScroll };
        if (isScroll && boundingBox && popoverRef && popoverIsOpened) {
            const { top, bottom } = popoverRef.getBoundingClientRect();
            if (top < boundingBox.top || bottom > boundingBox.bottom) {
                setPopoverIsOpened(false);
            }
        }
    }, [elementScroll, popoverRef, popoverIsOpened, setPopoverIsOpened]);
};
const useScrollDebounceListener = (container, scrollElement, dispatch) => {
    useLayoutEffect(() => {
        const current = container.current;
        if (!current)
            return;
        const cb = scrollListener(dispatch, scrollElement);
        const targetElement = "container" in current
            ? current.container.querySelector(`#${SCROLL_BAR_VIEW_ID}`)
            : current;
        if (!targetElement)
            return;
        const getBox = () => toBoundingBox(targetElement.getBoundingClientRect());
        const onScroll = () => cb(true, getBox());
        const onScrollEnd = debounce(() => cb(false, getBox()), 300);
        targetElement.addEventListener("scroll", onScroll, { passive: true });
        targetElement.addEventListener("scroll", onScrollEnd, { passive: true });
        return () => {
            targetElement.removeEventListener("scroll", onScroll);
            targetElement.removeEventListener("scroll", onScrollEnd);
            onScrollEnd.cancel?.();
        };
    }, [container, dispatch, scrollElement]);
};
export default useScrollDebounceListener;
